<div class="container" style="padding-top:100px;margin-bottom:200px;">
  <div class="row row-cols-3">
    <div class="col offset-4">
      <div class="card mat-elevation-z5 mt-5" >

        <div class="card-header d-flex justify-content-center">
          <mat-card-title>
            Logging in, please wait...
          </mat-card-title>
        </div>

        <mat-progress-bar *ngIf="isSubmitting" mode="indeterminate"></mat-progress-bar>
      </div>
    </div>
  </div>

  
  <div class="modal-overlay" *ngIf="showDropdownModal">
    <div class="modal-content mat-elevation-z8" [formGroup]="authForm">
     <mat-card-title class="justify-content-center">
            Select Facility
      </mat-card-title>
      <mat-form-field  appearance="fill" style="width:100%" >
        <mat-label >Select Facility</mat-label>
        <mat-select [(value)]="selectedOption" formControlName="facilityRole">
          <mat-option *ngFor="let option of facilityOptions" [value]="option.id">
            {{ option.name }}
          </mat-option>
        </mat-select>
         <mat-error *ngIf="authForm.get('facilityRole').hasError('required')">
          Please select a facility.
        </mat-error>
      </mat-form-field>

      <div class="modal-actions">
        <button mat-button (click)="closeDropdownModal()">Cancel</button>
        <button mat-raised-button color="primary" (click)="confirmSelection()">Confirm</button>
      </div>
    </div>
  </div>
</div>
